import React from 'react';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import {
  ArrowForwardRounded,
  CheckCircleRounded,
  LoginRounded,
  ScheduleRounded,
} from '@mui/icons-material';

function TestRegistrationClosed({ loading = false, onCreateAccount, onLogin }) {
  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', backgroundColor: '#ffffff' }}>
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
          px: 1,
          py: 1,
          backgroundColor: '#ffffff',
        }}
      >
        <Box sx={{ width: '100%', maxWidth: 435, ml: { xs: 0, sm: 4, md: 8 } }}>
          <img
            src="/assets/images/tivigo-logo-login.png"
            alt="Tivigo Logo"
            style={{ height: 50, objectFit: 'contain', marginBottom: 32 }}
          />

          {loading ? (
            <Box role="status" aria-live="polite" sx={{ py: 4, textAlign: 'center' }}>
              <CircularProgress size={30} />
              <Typography sx={{ mt: 2, color: '#6b7280', fontSize: '0.92rem', fontWeight: 600 }}>
                Test erişimi kontrol ediliyor...
              </Typography>
            </Box>
          ) : (
            <Box role="alert">
              <Box
                aria-hidden="true"
                sx={{
                  display: 'grid',
                  width: 58,
                  height: 58,
                  mb: 3,
                  placeItems: 'center',
                  border: '1px solid rgba(255, 138, 31, 0.18)',
                  borderRadius: '17px',
                  color: '#f97316',
                  background: 'linear-gradient(145deg, rgba(255,138,31,.13), rgba(124,102,255,.08))',
                  boxShadow: '0 16px 38px rgba(16, 17, 22, 0.08)',
                }}
              >
                <ScheduleRounded sx={{ fontSize: 29 }} />
              </Box>

              <Typography
                component="h1"
                variant="h4"
                sx={{
                  mb: '16px',
                  fontSize: '1.7rem',
                  fontWeight: 600,
                  letterSpacing: '-0.05em',
                  textTransform: 'capitalize',
                  cornerShape: 'superellipse(0.5)',
                }}
              >
                Test yayınları şu anda kapalı
              </Typography>

              <Typography
                sx={{
                  color: '#64666d',
                  fontSize: '0.9rem',
                  lineHeight: 1.75,
                  fontWeight: 500,
                  letterSpacing: 0,
                }}
              >
                Yeni test hesabı oluşturma geçici olarak durduruldu. Ücretsiz hesabınızı oluşturun,
                size uygun paketi satın alın ve Tivigo’yu tüm cihazlarınızda hemen kullanmaya başlayın.
              </Typography>

              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  mt: 2.5,
                  p: 1.6,
                  border: '1px solid rgba(16, 17, 22, 0.07)',
                  borderRadius: '12px',
                  color: '#3f4148',
                  backgroundColor: 'rgba(248, 248, 244, 0.72)',
                }}
              >
                <CheckCircleRounded sx={{ flex: '0 0 auto', color: '#16a36a', fontSize: 21 }} />
                <Typography
                  sx={{
                    fontSize: '0.75rem',
                    lineHeight: 1.45,
                    fontWeight: 400,
                    letterSpacing: '0.00938em',
                  }}
                >
                  Paketiniz satın alma sonrası anında aktif olur.
                </Typography>
              </Box>

              <Box sx={{ display: 'grid', gap: 1.25, mt: 3.5 }}>
                <Button
                  fullWidth
                  variant="contained"
                  endIcon={<ArrowForwardRounded />}
                  onClick={onCreateAccount}
                >
                  Ücretsiz Hesap Oluştur
                </Button>
                <Button
                  fullWidth
                  variant="outlined"
                  startIcon={<LoginRounded />}
                  onClick={onLogin}
                >
                  Zaten Hesabım Var
                </Button>
              </Box>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
}

export default TestRegistrationClosed;
